module.exports = __webpack_public_path__ + "static/media/ribbon-right.5b080661.svg";